import { Afiliaciones } from "../../Provider";

export default function getAffiliationsInfoService(zone, betweenDates){
  return Afiliaciones(zone, betweenDates);
}